import { Module, Subscription } from "@apis/index";
import OverviewCard from "@commons/cards/overview";
import Header from "@commons/header";
import BackButton from "@components/backButton";
import Button from "@components/button";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import { RootState } from "@store/index";
import { Form, Formik, useFormikContext } from "formik";
import { Receipt } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const CreateSubscription = () => {
  const { state } = useLocation();
  console.log(state);
  const [initialValues, setInitialValues] = useState({
    module: "",
    free: "",
    limitType: "Unlimited",
    name: "",
    price: "",
    validity: "",
    info: "",
    limitValue: "",
  });
  useEffect(() => {
    if (!state?.id) return;
    setInitialValues({
      module: state.module.id,
      free: state.isFree,
      limitType: state.isUnlimited ? "Unlimited" : "Use Limit",
      name: state.name,
      price: state.price,
      validity: state.validityInDays,
      info: state.content,
      limitValue: !state.isUnlimited ? state.orderLimit : "",
    });
  }, [state?.id]);
  const { data: modules } = useSelector((state: RootState) => state.modules);
  const fetchModules = async () =>
    await Module.list({ state: "modules", params: { isActive: true } });

  useEffect(() => {
    fetchModules();
  }, []);
  const limitOptions = [
    { id: "Unlimited", label: "Unlimited" },
    { id: "Use Limit", label: "Use Limit" },
  ];
  const navigate = useNavigate();
  const LimitInputField = () => {
    const { values } = useFormikContext<any>();
    return values.limitType === "Use Limit" ? (
      <Fields.Input
        name="limitValue"
        placeholder="Enter maximum order limit"
        type="number"
      />
    ) : null;
  };

  const handleSubmit = async (values: typeof initialValues, { resetForm }) => {
    const payload: any = {
      moduleId: Number(values.module),
      name: values.name,
      price: Number(values.price),
      validityInDays: Number(values.validity),
      content: values.info,
      isUnlimited: values.limitType === "Unlimited",
      isFree: !!values.free,
    };

    // Only send orderLimit when using limit
    if (values.limitType === "Use Limit") {
      payload.orderLimit = Number(values.limitValue);
    }
    if (state?.id) {
      console.log(payload);
      await Subscription.update({
        state: "subscriptions",
        data: payload,
        id: state?.id,
      });
    } else {
      console.log(payload);
      await Subscription.create({ state: "subscriptions", data: payload });
    }
    navigate("/admin/subscription-management/subscription-package");
    resetForm({
      module: "",
      free: "",
      limitType: "Unlimited",
      name: "",
      price: "",
      validity: "",
      info: "",
      limitValue: "",
    });
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      onSubmit={handleSubmit}
    >
      <Form>
        <Column>
          <BackButton path="/admin/subscription-management/subscription-package" />
          <Header title="Create Subscription" icon={Receipt} />

          <OverviewCard title="Package Information">
            <Column>
              <Fields.Switch
                name="free"
                label="Is Free?"
                styleWrapper="flex-direction:row;gap:12px"
              />
              <Row>
                <Fields.DropDown
                  name="module"
                  label="Module"
                  placeholder="---Select Module---"
                  options={modules}
                  titleAsKey="name"
                  valueAsKey="id"
                  styleInput="width:97.6%"
                  styleOptionsWrapper="width:100%"
                />
                <Fields.Input
                  name="name"
                  label="Package Name"
                  placeholder="Enter package name"
                />
                <Fields.Input
                  name="price"
                  label="Package Price"
                  placeholder="Enter package price"
                />
                <Fields.Input
                  name="validity"
                  label="Package Validity Days"
                  placeholder="Enter number of days"
                />
              </Row>
              <Fields.Editor name="info" label="Description" />
            </Column>
          </OverviewCard>

          <OverviewCard title="Set Limit">
            <Row styleRow="width:35%;align-items:center">
              <Fields.GroupRadioBox
                name="limitType"
                label="Subscription Limit Type"
                options={limitOptions}
                valueAsKey="id"
                titleAsKey="label"
              />

              <LimitInputField />
            </Row>
          </OverviewCard>

          <Row styleRow="justify-content:end">
            <Button title="Reset" variant="reset" />
            <Button title={state?.id ? "Update" : "Submit"} type="submit" />
          </Row>
        </Column>
      </Form>
    </Formik>
  );
};

export default CreateSubscription;
